import React from 'react';
import ControlButton from "../../Common/ControlButton";
import uiStore from "../../lib/stores/uiStore";
import ManageAccountsIcon from "@mui/icons-material/ManageAccounts";
import ThemeSelect from "../../lib/theme/components/ThemeSelect";
import Group from "@mui/icons-material/Group";
import SpeakerNotes from "@mui/icons-material/SpeakerNotes";
import Box from "../../Common/Box";

const Navbar = () => {
    return <Box row center height={"100px"}
                sx={{
                    overflow: "hidden",
                    zIndex: 1,
                }}
    >
        <ControlButton
                sx={{margin: "0 10px"}}
                width={35}
                enabled={uiStore.settingsVisible}
                icon={ManageAccountsIcon}
                label={"Account"}
                onClick={() => {
                    uiStore.settingsVisible = !uiStore.settingsVisible;
                }}
        />
        {uiStore.themeManagerEnabled &&
                <ThemeSelect sx={{overflow: "auto", marginRight: "10px"}} withControls/>}
        <ControlButton
                // sx={{marginLeft: "20px"}}
                width={35}
                enabled={uiStore.userListVisible}
                icon={Group}
                label={"Room"}
                onClick={() => {
                    uiStore.userListVisible = !uiStore.userListVisible;
                }}
        />
        <ControlButton
                sx={{marginLeft: "20px"}}
                width={35}
                enabled={uiStore.roomListVisible}
                icon={SpeakerNotes}
                label={"Rooms"}
                onClick={() => {
                    uiStore.roomListVisible = !uiStore.roomListVisible;
                }}
        />
    </Box>
};

export default Navbar;
